/**
 * Accepts either a bare URL or a full `<iframe ...>` embed snippet and
 * returns just the URL, so pasting either form into the admin works.
 * Returns "" for anything that isn't an http(s) URL.
 */
export function extractEmbedSrc(value) {
  if (!value) return "";
  const text = String(value).trim();
  const match = text.match(/<iframe[^>]*\ssrc\s*=\s*["']([^"']+)["']/i);
  const candidate = (match ? match[1] : text).trim();
  return /^https?:\/\//i.test(candidate) ? candidate : "";
}

/**
 * Embeds the Global E Tickets widget.
 *
 * The `src` is admin-editable (Site Media -> Page Embeds), so the event(s)
 * being sold can be swapped without a code change.
 */
const GlobalETicketsWidget = ({ src, title = "Tickets", maxWidth = "400px", height = 600 }) => {
  const url = extractEmbedSrc(src);
  if (!url) return null;

  return (
    <div className="w-full flex justify-center">
      <iframe
        src={url}
        title={title}
        width="100%"
        height={height}
        frameBorder="0"
        loading="lazy"
        style={{ borderRadius: "12px", maxWidth, border: "none" }}
        data-testid="global-etickets-widget"
      />
    </div>
  );
};

export default GlobalETicketsWidget;
